import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import Flexbox from "flexbox-react";
import ToastStore from "../../stores/ToastStore";
import { Drawer, NumericInput, Button, InputGroup, Icon, FormGroup, HTMLSelect, Dialog, Popover, Tooltip, Position, PopoverInteractionKind } from "@blueprintjs/core";
import { FilledButton, OutlinedButton, TextButton } from "../buttons-20250224T111359Z-001/buttons";
import axios from "axios";
import Cookies from "js-cookie";
import ScrollableDropdown from "../shared/ScrollableDropdown";
import EmptyStateNotice from "../goal_performance/EmptyStateNotice";
import QuestionDeleteConfirmation from "../goal_cycle/QuestionDeleteConfirmation";
import ConfirmationDialog from "../../views/ConfirmationDialog";
const ManagerQuestionDrawer = observer(({ isOpen, onClose, goalId, isWeightAllow }) => {

  const QuestionTypes = {
    Checkbox: "Checkbox",
    Radio: "Radio",
    TextBox: "TextBox",
    DropDown: "DropDown",
    ShortAnswer: "ShortAnswer",
    Files: "Files"
  };

  const DISPLAY_VALUES = {
    [QuestionTypes.TextBox]: "Detailed Answer",
    [QuestionTypes.ShortAnswer]: "Short Answer",
    [QuestionTypes.Files]: "Attachment",
    [QuestionTypes.DropDown]: "Select from Dropdown",
    [QuestionTypes.Radio]: "Multiple Choice (Select One)",
    [QuestionTypes.Checkbox]: "Multiple Choice (Select Multiple)",
  };

  const style = {
    roundedUploadButton: {
      borderRadius: "999px",
      backgroundColor: "#1870d5"
    },
    downloadSampleLink: {
      textDecoration: "none",
      fontWeight: 500,
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "15px"
    }
  };

  const ALL_JOB_PROFILE = { id: null, label: "All Profiles" };
  const ALL_QUESTION_CATEGORY = { id: null, label: "All Category" };

  const [jobProfileOptions, setJobProfileOptions] = useState([ALL_JOB_PROFILE]);
  const [selectedJobProfile, setSelectedJobProfile] = useState(ALL_JOB_PROFILE);
  const [showQuestionType, setShowQuestionType] = useState(true);
  const [optionIndex, setOptionIndex] = useState(1);
  const [selectedType, setSelectedType] = useState("TextBox");
  const [questionId, setQuestonId] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [answerOptions, setAnswerOptions] = useState({});
  const [questionGroups, setQuestionGroups] = useState([]);
  const [questionWeightage, setQuestionWeightage] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([ALL_QUESTION_CATEGORY]);
  const [selectedCategory, setSelectedCategory] = useState(ALL_QUESTION_CATEGORY);
  const [isRemarkDialogOpen, setIsRemarkDialogOpen] = useState(false);
  const [remarkQuestionTitle, setRemarkQuestionTitle] = useState("");
  const [remarkQuestionCategoryId, setRemarkQuestionCategoryId] = useState(null);
  const [remarkEditingId, setRemarkEditingId] = useState(null);
  const [isQuestionSaving, setIsQuestionSaving] = useState(false);
  const questionSavePending = useRef(false);
  const remarkSavePending = useRef(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);
  const [isRemarkSubmitting, setIsRemarkSubmitting] = useState(false);
  const [isDeleteRemarkDialogOpen, setIsDeleteRemarkDialogOpen] = useState(false);
  const [remarkToDeleteId, setRemarkToDeleteId] = useState(null);
  const [isDeleteRemarkSubmitting, setIsDeleteRemarkSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isQuestionDownloading, setIsQuestionDownloading] = useState(false);
  const [isQuestionUploading, setIsQuestionUploading] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const questionFileInputRef = useRef(null);
  const categoryFileInputRef = useRef(null);

  useEffect(() => {
    fetchQuestions();
  }, [selectedJobProfile?.id]);

  const fetchCategories = () => {
    axios
      .get(`${Cookies.get("apiEnv")}/question_categories`, {
        params: {
          goal_setting_id: goalId
        }
      })
      .then(res => {
        const categories = [ALL_QUESTION_CATEGORY, ...res.data.map(cat => ({
          id: cat.id,
          label: cat.name || cat.label || cat.category_name
        }))];

        setCategoryOptions(categories);

        if (!selectedCategory || selectedCategory.id === undefined) {
          setSelectedCategory(ALL_QUESTION_CATEGORY);
        }
      })
      .catch(err => {
        console.error("Error fetching categories", err);
        ToastStore.showToast("Failed to load categories", "danger");
      });
  };

  const fetchQuestions = () => {
    let url = `${Cookies.get("apiEnv")}/manager_assessments?goal_setting_id=${goalId}`;

    if (selectedJobProfile?.id) {
      url += `&job_profile_id=${selectedJobProfile.id}`;
    }

    axios.get(url)
      .then(response => {
        setQuestionGroups(response?.data || []);
      })
      .catch(error => {
        console.error("Error fetching questions", error);
      });
  };

  const fetchJobProfiles = () => {
    axios.get(`${Cookies.get("apiEnv")}/job_profiles `)
      .then(response => {
        const profiles = response.data.map(profile => ({
          id: profile.id,
          label: profile.name
        }));
        setJobProfileOptions([ALL_JOB_PROFILE, ...profiles]);
      })
      .catch(error => {
        console.error("Error fetching job profiles", error);
        ToastStore.showToast("Failed to load job profiles", "danger");
      })
  };

  const handleAddCategory = async (categoryName) => {
    try {
      const res = await axios.post(
        `${Cookies.get("apiEnv")}/question_categories`,
        { name: categoryName, goal_setting_id: goalId }
      );

      if (res?.data?.message) {
        ToastStore.showToast(res.data.message, "success");
      }

      await fetchCategories();

      if (res?.data?.id) {
        setSelectedCategory({
          id: res.data.id,
          label: res.data.name || categoryName
        });
      }

    } catch (error) {
      console.error("Error creating category", error);
      ToastStore.showToast(
        error?.response?.data?.message || "Failed to create category",
        "danger"
      );
    }
  };

  const openRemarkDialogForCategory = (categoryId) => {
    if (!categoryId || categoryId === "uncategorized" || categoryId === "null") return;
    setRemarkEditingId(null);
    setRemarkQuestionCategoryId(categoryId);
    setRemarkQuestionTitle("");
    setIsRemarkDialogOpen(true);
  };

  const handleCreateRemarkQuestion = async () => {
    if (!remarkQuestionTitle.trim()) {
      ToastStore.showToast("Title is required.", "warning");
      return;
    }
    if (!remarkQuestionCategoryId) {
      ToastStore.showToast("Please select a category.", "warning");
      return;
    }

    try {
      setIsRemarkSubmitting(true);

      const res = await axios.post(
        `${Cookies.get("apiEnv")}/question_categories/create_remark_question`,
        {
          goal_setting_id: goalId,
          question_category_id: remarkQuestionCategoryId,
          remark_type: "1",
          question: remarkQuestionTitle.trim()
        }
      );

      ToastStore.showToast(
        res?.data?.message || "Comment question created successfully",
        "success"
      );

      setIsRemarkDialogOpen(false);
      setRemarkQuestionTitle("");
      setRemarkQuestionCategoryId(null);
      setRemarkEditingId(null);
      await fetchQuestions();
    } catch (error) {
      ToastStore.showToast(
        error?.response?.data?.message || "Failed to create comment question",
        "danger"
      );
    } finally {
      setIsRemarkSubmitting(false);
    }
  };

  const handleUpdateRemarkQuestion = async () => {
    if (!remarkEditingId) return;

    if (!remarkQuestionTitle.trim()) {
      ToastStore.showToast("Title is required.", "warning");
      return;
    }
    if (!remarkQuestionCategoryId) {
      ToastStore.showToast("Please select a category.", "warning");
      return;
    }

    try {
      setIsRemarkSubmitting(true);

      const res = await axios.put(
        `${Cookies.get("apiEnv")}/question_categories/update_remark_question/${remarkEditingId}`,
        {
          goal_setting_id: goalId,
          question_category_id: remarkQuestionCategoryId,
          question: remarkQuestionTitle.trim()
        }
      );

      ToastStore.showToast(
        res?.data?.message || "Comment question updated successfully",
        "success"
      );

      setIsRemarkDialogOpen(false);
      setRemarkQuestionTitle("");
      setRemarkQuestionCategoryId(null);
      setRemarkEditingId(null);
      await fetchQuestions();
    } catch (error) {
      ToastStore.showToast(
        error?.response?.data?.message || "Failed to update comment question",
        "danger"
      );
    } finally {
      setIsRemarkSubmitting(false);
    }
  };

  const handleSaveRemarkQuestion = async () => {
    if (remarkSavePending.current) return;
    remarkSavePending.current = true;
    try {
      if (remarkEditingId) await handleUpdateRemarkQuestion();
      else await handleCreateRemarkQuestion();
    } finally {
      remarkSavePending.current = false;
    }
  };

  const openDeleteRemarkConfirmation = (remarkId) => {
    if (!remarkId) return;
    setRemarkToDeleteId(remarkId);
    setIsDeleteRemarkDialogOpen(true);
  };

  const openEditRemarkDialog = (remark, group) => {
    if (!remark?.id) return;
    setRemarkEditingId(remark.id);
    setRemarkQuestionTitle(remark.question || "");
    setRemarkQuestionCategoryId(remark.question_category_id || group?.category_id || null);
    setIsRemarkDialogOpen(true);
  };

  const handleDeleteRemarkQuestion = async (remarkId) => {
    if (!remarkId || !goalId || isDeleteRemarkSubmitting) return;

    setIsDeleteRemarkSubmitting(true);
    try {
      await axios.delete(
        `${Cookies.get("apiEnv")}/question_categories/delete_remark_question/${remarkId}`,
        { data: { goal_setting_id: goalId } }
      );
      ToastStore.showToast("Comment question deleted successfully", "success");
      setIsDeleteRemarkDialogOpen(false);
      setRemarkToDeleteId(null);
      await fetchQuestions();
    } catch (error) {
      ToastStore.showToast(
        error?.response?.data?.message || "Failed to delete comment question",
        "danger"
      );
    } finally {
      setIsDeleteRemarkSubmitting(false);
    }
  };

  useEffect(() => {
    fetchJobProfiles();
    fetchCategories();
  }, []);


  const handleAddOptions = () => {
    const optionKey = `option${optionIndex}`;
    setAnswerOptions(prev => ({ ...prev, [optionKey]: "" }));
    setOptionIndex(prev => prev + 1);
  };

  const handleOptionChange = (key, value) => {
    setAnswerOptions({ ...answerOptions, [key]: value });
  };

  const handleSaveQuestion = async () => {
    if (questionSavePending.current) return;
    if (!questionText.trim()) {
      ToastStore.showToast("Question text is required!", "danger");
      return;
    }

    // if (isWeightAllow && (questionWeightage === undefined || questionWeightage === 0 || questionWeightage === "")) {
    //   ToastStore.showToast("Weightage is required.!", "danger");
    //   return;
    // }

    // Validate that Radio, Dropdown, and Checkbox questions have at least one option
    const requiresOptions = [QuestionTypes.Radio, QuestionTypes.DropDown, QuestionTypes.Checkbox];
    if (requiresOptions.includes(selectedType) && Object.keys(answerOptions).length === 0) {
      ToastStore.showToast("Please add at least one option for question!", "danger");
      return;
    }

    // Validate that all options have values
    if (requiresOptions.includes(selectedType)) {
      const emptyOptions = Object.values(answerOptions).some(option => !option.trim());
      if (emptyOptions) {
        ToastStore.showToast("Please fill in all option values!", "danger");
        return;
      }
    }

    questionSavePending.current = true;
    setIsQuestionSaving(true);
    try {
      if (editingIndex !== null) {
        await axios.put(`${Cookies.get("apiEnv")}/manager_assessments`, {
          goal_setting_id: goalId,
          manager_assessment_question_id: questionId,
          question: questionText,
          question_type: selectedType,
          value: answerOptions,
          job_profile_id: selectedJobProfile?.id,
          ...(isWeightAllow && { weightage: questionWeightage }),
          ...(selectedCategory?.id && {
            question_category_id: selectedCategory.id
          })
        })
          .then(response => {
            fetchQuestions();
            setEditingIndex(null);
          });
      } else {
        await axios
          .post(`${Cookies.get("apiEnv")}/manager_assessments/create_question`, {
            goal_setting_id: goalId,
            question: questionText,
            question_type: selectedType,
            value: answerOptions,
            job_profile_id: selectedJobProfile?.id,
            ...(isWeightAllow && { weightage: questionWeightage }),
            ...(selectedCategory?.id && {
              question_category_id: selectedCategory.id
            })
          })
          .then(response => {
            fetchQuestions();
          });
      }
      resetForm();
    } catch (error) {
      ToastStore.showToast(String(error?.response?.data?.error || error?.response?.data?.message || "Failed to save question"), "danger");
    } finally {
      questionSavePending.current = false;
      setIsQuestionSaving(false);
    }
  };

  const handleEditQuestion = (question, group) => {

    const normalizedOptions =
      question.value && Object.keys(question.value).length > 0
        ? question.value
        : {};

    setSelectedType(question.question_type);
    setQuestionText(question.question);
    setAnswerOptions(normalizedOptions);
    setOptionIndex(Object.keys(normalizedOptions).length + 1);

    setQuestonId(question.id);
    setQuestionWeightage(question.weightage || "");
    setEditingIndex(question.id);

    if (group?.category_id && group.category_id !== "uncategorized") {
      const matchedCategory = categoryOptions.find(cat => cat.id === group.category_id);

      setSelectedCategory(
        matchedCategory || {
          id: group.category_id,
          label: group.category_name || "Category"
        }
      );
    } else {
      setSelectedCategory(null);
    }
  };

  const handleDeleteQuestion = (questionId) => axios.delete(
    `${Cookies.get("apiEnv")}/manager_assessments/${questionId}`
  );

  const defaultType = "TextBox";
  const resetForm = () => {
    setSelectedType(defaultType);
    setQuestionText("");
    setAnswerOptions({});
    setOptionIndex(1);
    setQuestionWeightage("");
    setEditingIndex(null);
    setQuestonId("");
  };

  const totalWeight = questionGroups.reduce((sum, group) => {
    return sum + group.questions.reduce((s, q) => s + (q.weightage || 0), 0);
  }, 0);
  const weightColor = totalWeight > 100 ? "red" : "green";
  const sortedQuestionGroups = [...questionGroups];

  const handleQuestionUploadClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    questionFileInputRef.current?.click();
  };

  const handleQuestionFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedExtensions = [
      "xls", "xlsx", "xlsm", "xlsb", "xlt", "xltx",
      "ods", "csv"
    ];

    const fileExt = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      ToastStore?.showToast?.("Invalid file format", "danger");
      questionFileInputRef.current.value = "";
      return;
    }

    const baseUrl = Cookies.get("apiEnv");
    if (!baseUrl) {
      ToastStore?.showToast?.("API base URL not found", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("goal_setting_id", String(goalId));
    if (selectedCategory?.id) {
      formData.append("category_name", selectedCategory.label);
    }

    try {
      setIsQuestionUploading(true);

      const response = await axios.post(
        `${baseUrl}/manager_assessments/import`,
        formData
      );

      ToastStore?.showToast?.(
        response?.data?.message || "File uploaded successfully",
        "success"
      );
      await fetchQuestions();
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "File upload failed";

      ToastStore?.showToast?.(message, "danger");
    } finally {
      setIsQuestionUploading(false);
      questionFileInputRef.current.value = "";
    }
  };

  const handleCategoryUploadClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    categoryFileInputRef.current?.click();
  };

  const handleCategoryFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedExtensions = [
      "xls", "xlsx", "xlsm", "xlsb", "xlt", "xltx",
      "ods", "csv"
    ];

    const fileExt = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      ToastStore?.showToast?.("Invalid file format", "danger");
      categoryFileInputRef.current.value = "";
      return;
    }

    const baseUrl = Cookies.get("apiEnv");
    if (!baseUrl) {
      ToastStore?.showToast?.("API base URL not found", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("goal_setting_id", String(goalId));

    try {
      setIsCategoryLoading(true);
      const response = await axios.post(
        `${baseUrl}/question_categories/import`,
        formData
      );

      ToastStore?.showToast?.(
        response?.data?.message || "File uploaded successfully",
        "success"
      );
      await fetchCategories();
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "File upload failed";

      ToastStore?.showToast?.(message, "danger");
    } finally {
      setIsCategoryLoading(false);
      categoryFileInputRef.current.value = "";
    }
  };

  const handleDownloadSample = () => {
    setIsDownloading(true);

    const link = document.createElement("a");
    link.href = "/sample_category_export.xlsx";
    link.download = "sample_category_export.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      setIsDownloading(false);
    }, 800);
  };

  const handleQuestionDownloadSample = () => {
    setIsQuestionDownloading(true);

    const link = document.createElement("a");
    link.href = "/Review_Sample_file.xlsx";
    link.download = "Review_Sample_file.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      setIsQuestionDownloading(false);
    }, 800);
  };

  return (
    <Drawer portalContainer={document.body} isOpen={isOpen} onClose={onClose} size={"90%"} title={"Create Review questions "}>
      <Flexbox
        flexDirection="column"
        flexGrow={1}
        padding="15px"
        style={{ height: "100%" }}
      >

        <Flexbox display="flex" flexDirection="row" justifyContent="flex-start" padding="15px" paddingBottom="0px" paddingTop="0px" >
          <div style={{ width: "220px", padding: "15px" }}>
            <ScrollableDropdown
              width={220}
              label={
                jobProfileOptions.find(opt => opt.id === selectedJobProfile.id)?.label ||
                "All"
              }
              items={jobProfileOptions}
              getKey={item => item.id}
              getLabel={item => item.label}
              enableSearch
              onSelect={item =>
                setSelectedJobProfile(item)

              }
            />
          </div>
        </Flexbox>

        <Flexbox flexDirection="row" flexGrow={1} padding="15px" paddingTop="0px" style={{ overflowY: "auto" }}>
          <Flexbox flexDirection="column" flexGrow={1} padding="15px" style={{ width: "55%" }}>
            <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", paddingRight: "15px" }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "0px" }}>Questions List</h3>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Popover
                  position={Position.BOTTOM_RIGHT}
                  interactionKind={PopoverInteractionKind.CLICK}
                  portalContainer={document.body}
                  content={
                    <div
                      style={{
                        borderRadius: "12px",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                        border: "1px solid #e5e7eb",
                        overflow: "hidden",
                        background: "#fff",
                        width: "260px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          padding: "12px 16px",
                          alignItems: "center",
                          cursor: isQuestionDownloading ? "not-allowed" : "pointer",
                          opacity: isQuestionDownloading ? 0.6 : 1,
                        }}
                        onClick={isQuestionDownloading ? undefined : handleQuestionDownloadSample}
                      >
                        <div
                          style={{
                            background: "#e0edff",
                            color: "#2d72d9",
                            borderRadius: "8px",
                            padding: "8px",
                            display: "flex",
                          }}
                        >
                          <Icon icon="download" />
                        </div>

                        <div>
                          <div style={{ fontWeight: 600 }}>Download Sample</div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                            Download a sample file for the import format
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          padding: "12px 16px",
                          alignItems: "center",
                          cursor: isQuestionUploading ? "not-allowed" : "pointer",
                          background: "#f3f4f6",
                          opacity: isQuestionUploading ? 0.6 : 1,
                        }}
                        onClick={isQuestionUploading ? undefined : handleQuestionUploadClick}
                      >
                        <div
                          style={{
                            background: "#dcfce7",
                            color: "#16a34a",
                            borderRadius: "8px",
                            padding: "8px",
                            display: "flex",
                          }}
                        >
                          <Icon icon="upload" />
                        </div>

                        <div>
                          <div style={{ fontWeight: 600 }}>Upload File</div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                            Upload a file to import question data
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                >
                  <Button
                    style={{
                      borderRadius: "10px",
                      color: "#2d72d9",
                      // backgroundColor: "rgba(45, 114, 217, 0.08)",
                      border: "1px solid rgba(45, 114, 217, 0.3)",
                      padding: "9px 18px",
                      fontWeight: 500,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    icon="import"
                    rightIcon="caret-down"
                    text="Import Questions"
                    disabled={isQuestionDownloading || isQuestionUploading}
                  />
                </Popover>
                <input
                  type="file"
                  ref={questionFileInputRef}
                  style={{ display: "none" }}
                  accept=".xls,.xlsx,.xlsm,.xlsb,.xlt,.xltx,.ods,.csv"
                  onChange={handleQuestionFileChange}
                />
              </div>
            </div>
            {isWeightAllow && (
              <>
                {" "}
                <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: weightColor }}>
                  Total Weightage: {totalWeight}
                </div>
                {totalWeight > 100 && (
                  <div style={{ color: "red", fontSize: "14px", marginBottom: "10px" }}>
                    ⚠️ Total Weightage should be 100 for correct calculation.
                  </div>
                )}
              </>
            )}

            <div
              style={{
                overflowY: "auto",
                height: "calc(100vh - 220px)",
                paddingRight: 16
              }}
            >
              {questionGroups.length === 0 ? (
                <Flexbox justifyContent="center" alignItems="center" height="500px">
                  <EmptyStateNotice
                    title="No Questions Added"
                    description="Assessment questions are not created yet. Please add questions to get started."
                  />
                </Flexbox>
              ) : (
                sortedQuestionGroups?.map((group, groupIndex) => (
                  <div key={groupIndex} style={{ marginBottom: 25 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, marginBottom: 10 }}>
                      <div style={{ fontWeight: "bold", fontSize: 15, color: "#1870D5" }}>
                        {group.category_name || (group.category_id === "uncategorized" || group.category_id === null || group.category_id === "null" ? "Uncategorized" : "")}
                      </div>
                      {group.category_id && group.category_id !== "uncategorized" && group.category_id !== "null" && (
                        <Button
                          text="+ Add Comment"
                          minimal
                          onClick={() => openRemarkDialogForCategory(group.category_id)}
                          style={{ color: "#1870D5", whiteSpace: "nowrap" }}
                        />
                      )}
                    </div>
                    {group.remark_questions?.length > 0 && (
                      <div style={{ marginTop: 8 }}>
                        {group.remark_questions.map((remark) => (
                          <div
                            key={remark.id}
                            style={{
                              padding: "6px 3px",
                              marginBottom: "6px",
                              fontSize: "15px"
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 10
                              }}
                            >
                              <div style={{ minWidth: 0 }}>
                                <strong>Comment:</strong> {remark.question}
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <div
                                  className="edit-icon"
                                  onClick={() => openEditRemarkDialog(remark, group)}
                                  style={{ cursor: "pointer" }}
                                  title="Edit"
                                >
                                  <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    strokeWidth="1.5"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      className="edit-icon-path"
                                      strokeWidth="1.5"
                                      d="M7.63704 21.2615H2.51904L2.69554 16.1885L16.1595 3.1285C16.4168 2.87888 16.761 2.73903 17.1194 2.73847C17.4779 2.73791 17.8225 2.87669 18.0805 3.1255L21.059 5.9975C21.1916 6.12538 21.2973 6.27848 21.3698 6.44778C21.4424 6.61708 21.4803 6.79918 21.4815 6.98337C21.4827 7.16756 21.447 7.35012 21.3766 7.52033C21.3062 7.69053 21.2025 7.84495 21.0715 7.9745L7.63704 21.2615ZM3.47254 20.3385H7.25854L20.4235 7.3195C20.4672 7.27634 20.5018 7.22488 20.5253 7.16815C20.5488 7.11142 20.5607 7.05056 20.5603 6.98916C20.56 6.92776 20.5473 6.86705 20.5231 6.81061C20.499 6.75416 20.4637 6.70313 20.4195 6.6605L17.441 3.7885C17.3552 3.70538 17.2403 3.65891 17.1208 3.65891C17.0013 3.65891 16.8864 3.70538 16.8005 3.7885L3.60054 16.5885L3.47254 20.3385Z"
                                      fill="#707070"
                                    />
                                    <path
                                      className="edit-icon-path"
                                      strokeWidth="1.5"
                                      d="M18.8589 9.5245L14.4719 5.21L15.2029 4.491L19.5899 8.8055L18.8589 9.5245Z"
                                      fill="#707070"
                                    />
                                  </svg>
                                </div>

                                <div
                                  className="edit-icon"
                                  onClick={() => openDeleteRemarkConfirmation(remark.id)}
                                  style={{ cursor: "pointer" }}
                                  title="Delete"
                                >
                                  <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      className="edit-icon-path"
                                      d="M15.8449 21.5H8.17195C7.71676 21.5023 7.27748 21.3327 6.94192 21.0251C6.60635 20.7175 6.39923 20.2947 6.36195 19.841L5.22595 6.78799H18.791L17.655 19.841C17.6174 20.2946 17.4103 20.7173 17.0747 21.0248C16.7392 21.3324 16.3001 21.502 15.8449 21.5ZM6.31695 7.78799L7.35795 19.754C7.3748 19.9578 7.46784 20.1478 7.61852 20.286C7.7692 20.4243 7.96645 20.5007 8.17095 20.5H15.8449C16.0496 20.5007 16.247 20.4241 16.3977 20.2857C16.5484 20.1472 16.6413 19.957 16.658 19.753L17.699 7.78799H6.31695Z"
                                      fill="#707070"
                                    />
                                    <path
                                      className="edit-icon-path"
                                      d="M20.373 7.78799H3.5C3.36739 7.78799 3.24021 7.73532 3.14645 7.64155C3.05268 7.54778 3 7.4206 3 7.28799C3 7.15539 3.05268 7.02821 3.14645 6.93444C3.24021 6.84067 3.36739 6.78799 3.5 6.78799H20.373C20.5056 6.78799 20.6328 6.84067 20.7266 6.93444C20.8203 7.02821 20.873 7.15539 20.873 7.28799C20.873 7.4206 20.8203 7.54778 20.7266 7.64155C20.6328 7.73532 20.5056 7.78799 20.373 7.78799Z"
                                      fill="#707070"
                                    />
                                    <path
                                      className="edit-icon-path"
                                      d="M8.48605 2.5H15.7C16.0143 2.50079 16.3154 2.62603 16.5374 2.84831C16.7595 3.07058 16.8845 3.37179 16.885 3.686V7.786H7.30005V3.686C7.30058 3.37162 7.4257 3.07026 7.648 2.84796C7.87031 2.62565 8.17166 2.50053 8.48605 2.5ZM15.886 6.788V3.686C15.886 3.63667 15.8665 3.58936 15.8316 3.55448C15.7967 3.5196 15.7494 3.5 15.7 3.5H8.48605C8.43672 3.5 8.38941 3.5196 8.35453 3.55448C8.31965 3.58936 8.30005 3.63667 8.30005 3.686V6.786L15.886 6.788Z"
                                      fill="#707070"
                                    />
                                    <path
                                      className="edit-icon-path"
                                      d="M10.297 17.158C10.1644 17.158 10.0372 17.1053 9.94344 17.0115C9.84968 16.9178 9.797 16.7906 9.797 16.658V10.564C9.797 10.4314 9.84968 10.3042 9.94344 10.2104C10.0372 10.1167 10.1644 10.064 10.297 10.064C10.4296 10.064 10.5568 10.1167 10.6506 10.2104C10.7443 10.3042 10.797 10.4314 10.797 10.564V16.658C10.797 16.7906 10.7443 16.9178 10.6506 17.0115C10.5568 17.1053 10.4296 17.158 10.297 17.158Z"
                                      fill="#707070"
                                    />
                                    <path
                                      className="edit-icon-path"
                                      d="M14.116 17.158C13.9834 17.158 13.8562 17.1053 13.7624 17.0115C13.6686 16.9178 13.616 16.7906 13.616 16.658V10.564C13.616 10.4314 13.6686 10.3042 13.7624 10.2104C13.8562 10.1167 13.9834 10.064 14.116 10.064C14.2486 10.064 14.3758 10.1167 14.4695 10.2104C14.5633 10.3042 14.616 10.4314 14.616 10.564V16.658C14.616 16.7906 14.5633 16.9178 14.4695 17.0115C14.3758 17.1053 14.2486 17.158 14.116 17.158Z"
                                      fill="#707070"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {group.questions.map((q, index) => (
                      <div
                        key={q.id}
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "12px",
                          padding: "16px",
                          marginBottom: "8px",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
                        }}
                      >
                        <div style={{ display: "flex", fontSize: "16px", justifyContent: "space-between", alignItems: "center" }}>
                          <div onClick={() => handleEditQuestion(q, group)} style={{ flex: 1, cursor: "pointer" }}>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#333", marginBottom: "4px" }}>
                              {q.question}
                              {isWeightAllow && <p style={{ fontSize: "12px", color: "#888" }}>Weight:{q.weightage}</p>}
                            </div>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div
                              className="edit-icon"
                              onClick={() => handleEditQuestion(q, group)}
                              style={{ cursor: "pointer" }}
                            >
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                strokeWidth="1.5"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  className="edit-icon-path"
                                  strokeWidth="1.5"
                                  d="M7.63704 21.2615H2.51904L2.69554 16.1885L16.1595 3.1285C16.4168 2.87888 16.761 2.73903 17.1194 2.73847C17.4779 2.73791 17.8225 2.87669 18.0805 3.1255L21.059 5.9975C21.1916 6.12538 21.2973 6.27848 21.3698 6.44778C21.4424 6.61708 21.4803 6.79918 21.4815 6.98337C21.4827 7.16756 21.447 7.35012 21.3766 7.52033C21.3062 7.69053 21.2025 7.84495 21.0715 7.9745L7.63704 21.2615ZM3.47254 20.3385H7.25854L20.4235 7.3195C20.4672 7.27634 20.5018 7.22488 20.5253 7.16815C20.5488 7.11142 20.5607 7.05056 20.5603 6.98916C20.56 6.92776 20.5473 6.86705 20.5231 6.81061C20.499 6.75416 20.4637 6.70313 20.4195 6.6605L17.441 3.7885C17.3552 3.70538 17.2403 3.65891 17.1208 3.65891C17.0013 3.65891 16.8864 3.70538 16.8005 3.7885L3.60054 16.5885L3.47254 20.3385Z"
                                  fill="#707070"
                                />
                                <path
                                  className="edit-icon-path"
                                  strokeWidth="1.5"
                                  d="M18.8589 9.5245L14.4719 5.21L15.2029 4.491L19.5899 8.8055L18.8589 9.5245Z"
                                  fill="#707070"
                                />
                              </svg>
                            </div>

                            <div
                              className="edit-icon"
                              onClick={() => setQuestionToDelete(q)}
                              style={{ cursor: "pointer" }}

                            >
                              <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  className="edit-icon-path"
                                  d="M15.8449 21.5H8.17195C7.71676 21.5023 7.27748 21.3327 6.94192 21.0251C6.60635 20.7175 6.39923 20.2947 6.36195 19.841L5.22595 6.78799H18.791L17.655 19.841C17.6174 20.2946 17.4103 20.7173 17.0747 21.0248C16.7392 21.3324 16.3001 21.502 15.8449 21.5ZM6.31695 7.78799L7.35795 19.754C7.3748 19.9578 7.46784 20.1478 7.61852 20.286C7.7692 20.4243 7.96645 20.5007 8.17095 20.5H15.8449C16.0496 20.5007 16.247 20.4241 16.3977 20.2857C16.5484 20.1472 16.6413 19.957 16.658 19.753L17.699 7.78799H6.31695Z"
                                  fill="#707070"
                                />
                                <path
                                  className="edit-icon-path"
                                  d="M20.373 7.78799H3.5C3.36739 7.78799 3.24021 7.73532 3.14645 7.64155C3.05268 7.54778 3 7.4206 3 7.28799C3 7.15539 3.05268 7.02821 3.14645 6.93444C3.24021 6.84067 3.36739 6.78799 3.5 6.78799H20.373C20.5056 6.78799 20.6328 6.84067 20.7266 6.93444C20.8203 7.02821 20.873 7.15539 20.873 7.28799C20.873 7.4206 20.8203 7.54778 20.7266 7.64155C20.6328 7.73532 20.5056 7.78799 20.373 7.78799Z"
                                  fill="#707070"
                                />
                                <path
                                  className="edit-icon-path"
                                  d="M8.48605 2.5H15.7C16.0143 2.50079 16.3154 2.62603 16.5374 2.84831C16.7595 3.07058 16.8845 3.37179 16.885 3.686V7.786H7.30005V3.686C7.30058 3.37162 7.4257 3.07026 7.648 2.84796C7.87031 2.62565 8.17166 2.50053 8.48605 2.5ZM15.886 6.788V3.686C15.886 3.63667 15.8665 3.58936 15.8316 3.55448C15.7967 3.5196 15.7494 3.5 15.7 3.5H8.48605C8.43672 3.5 8.38941 3.5196 8.35453 3.55448C8.31965 3.58936 8.30005 3.63667 8.30005 3.686V6.786L15.886 6.788Z"
                                  fill="#707070"
                                />
                                <path
                                  className="edit-icon-path"
                                  d="M10.297 17.158C10.1644 17.158 10.0372 17.1053 9.94344 17.0115C9.84968 16.9178 9.797 16.7906 9.797 16.658V10.564C9.797 10.4314 9.84968 10.3042 9.94344 10.2104C10.0372 10.1167 10.1644 10.064 10.297 10.064C10.4296 10.064 10.5568 10.1167 10.6506 10.2104C10.7443 10.3042 10.797 10.4314 10.797 10.564V16.658C10.797 16.7906 10.7443 16.9178 10.6506 17.0115C10.5568 17.1053 10.4296 17.158 10.297 17.158Z"
                                  fill="#707070"
                                />
                                <path
                                  className="edit-icon-path"
                                  d="M14.116 17.158C13.9834 17.158 13.8562 17.1053 13.7624 17.0115C13.6686 16.9178 13.616 16.7906 13.616 16.658V10.564C13.616 10.4314 13.6686 10.3042 13.7624 10.2104C13.8562 10.1167 13.9834 10.064 14.116 10.064C14.2486 10.064 14.3758 10.1167 14.4695 10.2104C14.5633 10.3042 14.616 10.4314 14.616 10.564V16.658C14.616 16.7906 14.5633 16.9178 14.4695 17.0115C14.3758 17.1053 14.2486 17.158 14.116 17.158Z"
                                  fill="#707070"
                                />
                              </svg>
                            </div>

                          </div>
                        </div>

                        {q.value && Object.values(q.value).length > 0 && (
                          <ul style={{ marginTop: 10 }}>
                            {Object.values(q.value).map((opt, i) => (
                              <li key={i}>{opt}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                ))
              )}
            </div>
          </Flexbox>

          <Flexbox flexDirection="column" flexGrow={1} padding="15px" style={{ width: "45%", borderLeft: "2px solid #e5e5e5", paddingLeft: "12px" }}>
            {(showQuestionType || selectedType) && (
              <>
                <div style={{ marginBottom: 15, display: "flex", gap: 10 }}>
                  <ScrollableDropdown
                    width={220}
                    label={
                      categoryOptions.find(opt => opt.id === selectedCategory?.id)?.label || "All Category"
                    }
                    items={categoryOptions}
                    getKey={item => item.id}
                    getLabel={item => item.label}
                    enableSearch
                    onSelect={item => setSelectedCategory(item)}
                  />

                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    {isAddingCategory ? (
                      <input
                        autoFocus
                        value={newCategory}
                        placeholder="Enter category"
                        onChange={(e) => setNewCategory(e.target.value)}
                        onKeyDown={async (e) => {
                          if (e.key === "Enter" && newCategory.trim()) {
                            await handleAddCategory(newCategory.trim());
                            setNewCategory("");
                            setIsAddingCategory(false);
                          }

                          if (e.key === "Escape") {
                            setIsAddingCategory(false);
                            setNewCategory("");
                          }
                        }}
                        onBlur={() => setIsAddingCategory(false)}
                        style={{
                          height: 32,
                          padding: "0 8px",
                          borderRadius: 4,
                          border: "1px solid #ccc",
                          minWidth: 160
                        }}
                      />
                    ) : (
                      <Button
                        text="+ Add Category"
                        minimal
                        onClick={() => {
                          setIsAddingCategory(true);
                          setNewCategory("");
                        }}
                        style={{ color: "#1870D5" }}
                      />
                    )}

                    <Popover
                      position={Position.BOTTOM_RIGHT}
                      interactionKind={PopoverInteractionKind.CLICK}
                      portalContainer={document.body}
                      content={
                        <div
                          style={{
                            borderRadius: "12px",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                            border: "1px solid #e5e7eb",
                            overflow: "hidden",
                            background: "#fff",
                            width: "260px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              padding: "12px 16px",
                              alignItems: "center",
                              cursor: isDownloading ? "not-allowed" : "pointer",
                              opacity: isDownloading ? 0.6 : 1,
                            }}
                            onClick={isDownloading ? undefined : handleDownloadSample}
                          >
                            <div
                              style={{
                                background: "#e0edff",
                                color: "#2d72d9",
                                borderRadius: "8px",
                                padding: "8px",
                                display: "flex",
                              }}
                            >
                              <Icon icon="download" />
                            </div>

                            <div>
                              <div style={{ fontWeight: 600 }}>Download Sample</div>
                              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                Download a sample file for the import format
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              padding: "12px 16px",
                              alignItems: "center",
                              cursor: isCategoryLoading ? "not-allowed" : "pointer",
                              background: "#f3f4f6",
                              opacity: isCategoryLoading ? 0.6 : 1,
                            }}
                            onClick={isCategoryLoading ? undefined : handleCategoryUploadClick}
                          >
                            <div
                              style={{
                                background: "#dcfce7",
                                color: "#16a34a",
                                borderRadius: "8px",
                                padding: "8px",
                                display: "flex",
                              }}
                            >
                              <Icon icon="upload" />
                            </div>

                            <div>
                              <div style={{ fontWeight: 600 }}>Upload File</div>
                              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                Upload a file to import category data
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    >
                      <Button
                        style={{
                          borderRadius: "10px",
                          color: "#2d72d9",
                          // backgroundColor: "rgba(45, 114, 217, 0.08)",
                          border: "1px solid rgba(45, 114, 217, 0.3)",
                          padding: "9px 18px",
                          fontWeight: 500,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                        icon="import"
                        rightIcon="caret-down"
                        text="Import Categories"
                        disabled={isDownloading || isCategoryLoading}
                      />
                    </Popover>
                    <input
                      type="file"
                      ref={categoryFileInputRef}
                      style={{ display: "none" }}
                      accept=".xls,.xlsx,.xlsm,.xlsb,.xlt,.xltx,.ods,.csv"
                      onChange={handleCategoryFileChange}
                    />
                  </div>
                </div>

                <Dialog
                  portalContainer={document.body}
                  isOpen={isRemarkDialogOpen}
                  onClose={() => {
                    if (isRemarkSubmitting) return;
                    setIsRemarkDialogOpen(false);
                    setRemarkQuestionTitle("");
                    setRemarkQuestionCategoryId(null);
                    setRemarkEditingId(null);
                  }}
                  title={remarkEditingId ? "Edit Comment" : "Add Comment"}
                  canEscapeKeyClose={!isRemarkSubmitting}
                  canOutsideClickClose={!isRemarkSubmitting}
                >
                  <div className="bp3-dialog-body push-20-b push-20-t">
                    <div style={{ fontSize: 14, marginBottom: 8, fontWeight: 600 }}>
                      Title
                    </div>
                    <input
                      autoFocus
                      placeholder="Enter title"
                      disabled={isRemarkSubmitting}
                      value={remarkQuestionTitle}
                      onChange={e => setRemarkQuestionTitle(e.target.value)}
                      style={{
                        width: "100%",
                        border: "1px solid #e1e1e1",
                        boxShadow: "none",
                        borderRadius: 4,
                        padding: "8px 10px"
                      }}
                    />
                  </div>

                  <div className="bp3-dialog-footer">
                    <div className="bp3-dialog-footer-actions" style={{ display: "flex", alignItems: "center" }}>
                      <FilledButton
                        text="Save"
                        onClick={handleSaveRemarkQuestion}
                        disabled={isRemarkSubmitting}
                        style={{ marginRight: 8 }}
                      />
                      <TextButton
                        text="Cancel"
                        onClick={() => {
                          if (isRemarkSubmitting) return;
                          setIsRemarkDialogOpen(false);
                          setRemarkQuestionTitle("");
                          setRemarkQuestionCategoryId(null);
                          setRemarkEditingId(null);
                        }}
                        disabled={isRemarkSubmitting}
                      />
                      {isRemarkSubmitting && <img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Saving..." role="status" />}
                    </div>
                  </div>
                </Dialog>
                {questionToDelete && <QuestionDeleteConfirmation
                  question={questionToDelete}
                  onClose={() => setQuestionToDelete(null)}
                  onDelete={handleDeleteQuestion}
                  onDeleted={fetchQuestions}
                />}
                <ConfirmationDialog
                  isOpen={isDeleteRemarkDialogOpen}
                  onClose={() => {
                    if (isDeleteRemarkSubmitting) return;
                    setIsDeleteRemarkDialogOpen(false);
                    setRemarkToDeleteId(null);
                  }}
                  onConfirm={() => handleDeleteRemarkQuestion(remarkToDeleteId)}
                  title="Delete Comment"
                  message="Are you sure you want to delete "
                  itemName={questionGroups.reduce((remarks, group) => remarks.concat(group.remark_questions || []), []).find(remark => remark.id === remarkToDeleteId)?.question || "this comment"}
                  confirmText="Delete"
                  confirmIntent="danger"
                  isSubmitting={isDeleteRemarkSubmitting}
                  submittingText="Deleting..."
                  loadingIndicator={<img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Deleting..." role="status" />}
                />
                <FormGroup label="Type">
                  <HTMLSelect
                    fill
                    options={Object.entries(DISPLAY_VALUES).map(([value, label]) => ({ value, label }))}
                    value={selectedType || "TextBox"}
                    onChange={e => setSelectedType(e.target.value)}
                    style={{ border: "1px solid #e1e1e1", boxShadow: "none" }}
                  />
                </FormGroup>

                <FormGroup label="Question">
                  {/* <InputGroup
                    placeholder="Please enter your question"
                    value={questionText}
                    onChange={e => setQuestionText(e.target.value)}
                    fill
                    style={{ border: "1px solid #e1e1e1", boxShadow: "none" }}
                  /> */}
                  <textarea
                    className="bp3-input bp3-textarea bp3-fill"
                    rows={5}
                    dir="auto"
                    value={questionText}
                    onChange={(e) => setQuestionText(e.target.value)}
                    placeholder="Please enter your question"
                    style={{ border: "1px solid #e1e1e1", boxShadow: "none" }}
                  />
                </FormGroup>

                {selectedType !== QuestionTypes.ShortAnswer && selectedType !== QuestionTypes.TextBox && selectedType !== QuestionTypes.Files && (
                  <FormGroup label="Options">
                    {Object.entries(answerOptions).map(([key, option], index) => (
                      <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                        <InputGroup
                          value={option}
                          placeholder="Option"
                          fill
                          onChange={e => handleOptionChange(key, e.target.value)}
                          style={{ border: "1px solid #e1e1e1", boxShadow: "none" }}
                        />
                        <Button
                          icon="trash"
                          minimal
                          onClick={() => {
                            const updatedOptions = { ...answerOptions };
                            delete updatedOptions[key];
                            setAnswerOptions(updatedOptions);
                          }}
                          style={{ marginLeft: 8 }}
                        />
                      </div>
                    ))}
                    <Button
                      text="+ Add Option"
                      onClick={handleAddOptions}
                      minimal
                      // intent="primary"
                      style={{ color: "#1870D5" }}
                    />
                  </FormGroup>
                )}
                {isWeightAllow && (
                  <FormGroup label="weightage">
                    <NumericInput
                      allowNumericCharactersOnly={true}
                      name="weightage"
                      placeholder="weight"
                      min={0}
                      max={100}
                      value={questionWeightage}
                      onValueChange={val => setQuestionWeightage(val)}
                      buttonPosition="none"
                    />
                  </FormGroup>
                )}
                <div style={{ marginTop: 20, display: "flex", alignItems: "center", gap: 8 }}>
                  <FilledButton text={editingIndex !== null ? "Update Question" : "Save Question"} onClick={handleSaveQuestion} disabled={isQuestionSaving} />
                  {isQuestionSaving && <img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Saving..." role="status" />}
                </div>
              </>
            )}
          </Flexbox>
        </Flexbox>

      </Flexbox>

    </Drawer>
  );
});

export default ManagerQuestionDrawer;
